<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
    <div class="vx-row">
      <div class="w-full">
        <div
          slot="no-body"
          class="tabs-container inventory_tabSec pt-6"
          id="view-customer-tab"
        >
          <vs-tabs
            alignment="fixed"
            v-model="activeTab"
            class="tab-action-btn-fill-conatiner"
          >
            <vs-tab :label="$t('system.label.GlobalConfiguration')">
              <div>
                <vx-card>
                  <vs-table
                    :max-items="paginationItems[1]"
                    pagination
                    :data="configurationsData"
                    :description="false"
                    search
                    :description-items="paginationItems"
                    description-title="Registries"
                    description-connector="of"
                    description-body="Pages"
                  >
                    <template slot="header">
                      <div class="list-heading1">
                        {{ $t("system.label.GlobalConfiguration") }}
                      </div>
                      <div class="mr-2 mb-1 order-1">
                        <vs-button
                          icon-pack="feather"
                          icon="icon-plus"
                          @click="createConfigurationPopup = true"
                          size="small"
                          >{{ $t("system.label.AddConfiguration") }}</vs-button
                        >
                      </div>
                    </template>
                    <template slot="thead">
                      <th>{{ $t("system.label.Module") }}</th>
                      <th width="15%">{{ $t("system.label.Name") }}</th>
                      <th>{{ $t("system.label.Description") }}</th>
                      <th>{{ $t("system.label.Value") }}</th>
                      <th>{{ $t("system.label.Enabled") }}</th>
                      <th class="tHeadCenter">
                        {{ $t("system.label.Action") }}
                      </th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="index"
                        :data="configurationsData"
                        v-for="(configurationsData, index) in data"
                      >
                        <vs-td :data="configurationsData.module">{{
                          configurationsData.module
                        }}</vs-td>
                        <vs-td :data="configurationsData.name">{{
                          configurationsData.name
                        }}</vs-td>
                        <vs-td :data="configurationsData.description">{{
                          configurationsData.description
                        }}</vs-td>
                        <vs-td
                          :data="configurationsData.value"
                          class="width15"
                          >{{ configurationsData.value }}</vs-td
                        >
                        <vs-td :data="configurationsData.enabled"
                          ><vs-switch
                            v-model="configurationsData.enabled"
                            @change="
                              updateFlag(
                                configurationsData.id,
                                configurationsData.enabled
                              )
                            "
                        /></vs-td>

                        <vs-td class="whitespace-no-wrap">
                          <div class="container_img">
                            <feather-icon
                              icon="EditIcon"
                              :title="$t('system label.Edit')"
                              svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                              @click.stop="
                                editGlobalConfigValue(configurationsData)
                              "
                              class="icon_row"
                            />
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </div>
            </vs-tab>
            <vs-tab :label="$t('system.label.PaymentGatewayConfiguration')">
              <div>
                <vx-card>
                  <vs-table
                    :max-items="paginationItems[1]"
                    pagination
                    :data="paymentGatewayConfigsData"
                    :description="false"
                    search
                    :description-items="paginationItems"
                    description-title="Registries"
                    description-connector="of"
                    description-body="Pages"
                  >
                    <template slot="header">
                      <div class="list-heading1">
                        {{ $t("system.label.PaymentGatewayConfiguration") }}
                      </div>
                      <div class="mr-2 mb-1 order-1"></div>
                    </template>
                    <template slot="thead">
                      <th>{{ $t("system.label.Name") }}</th>
                      <th>{{ $t("system.label.Enabled") }}</th>
                      <th>{{ $t("system.label.Value") }}</th>
                      <th>{{ $t("system.label.Action") }}</th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="index"
                        :data="paymentGatewayConfigsData"
                        v-for="(paymentGatewayConfigsData, index) in data"
                      >
                        <vs-td :data="paymentGatewayConfigsData.name">{{
                          paymentGatewayConfigsData.name
                        }}</vs-td>
                        <vs-td :data="paymentGatewayConfigsData.enabled">{{
                          paymentGatewayConfigsData.enabled
                        }}</vs-td>

                        <vs-td
                          :data="paymentGatewayConfigsData.value"
                          class="width20"
                          >{{ paymentGatewayConfigsData.value }}</vs-td
                        >

                        <vs-td class="whitespace-no-wrap">
                          <vs-td :data="paymentGatewayConfigsData.enabled"
                            ><vs-switch
                              v-model="paymentGatewayConfigsData.enabled"
                              @change="
                                updatePaymentGatewayFlag(
                                  paymentGatewayConfigsData.id,
                                  paymentGatewayConfigsData.enabled
                                )
                              "
                          /></vs-td>
                          <feather-icon
                            v-if="paymentGatewayConfigsData.value"
                            icon="EditIcon"
                            :title="$t('system.label.Edit')"
                            svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                            @click.stop="
                              editPaymentGatwayConfig(paymentGatewayConfigsData)
                            "
                            class="icon_row"
                          />
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </div>
            </vs-tab>
            <vs-tab :label="$t('system.label.Hooks')">
              <div>
                <vx-card>
                  <vs-table
                    :max-items="paginationItems[1]"
                    pagination
                    :data="eventactionMappingData"
                    :description="false"
                    search
                    :description-items="paginationItems"
                    description-title="Registries"
                    description-connector="of"
                    description-body="Pages"
                  >
                    <template slot="header">
                      <div class="list-heading">
                        {{ $t("system.label.Hooks") }}
                      </div>
                      <div class="mr-2 mb-1 order-1">
                        <vs-button
                          icon-pack="feather"
                          icon="icon-plus"
                          @click="
                            $router.push('/createEventAction').catch(() => {})
                          "
                          size="small"
                          >{{ $t("system.label.CreateEvent") }}</vs-button
                        >
                      </div>
                    </template>
                    <template slot="thead">
                      <th>{{ $t("system.label.Event") }}</th>
                      <th>{{ $t("system.label.Action") }}</th>
                      <th>{{ $t("system.label.Process") }}</th>
                      <th>{{ $t("system.label.OrderBy") }}</th>
                      <th>{{ $t("system.label.PrePost") }}</th>
                      <th>{{ $t("system.label.ProcessParams") }}</th>
                      <th>{{ $t("system.label.IsSynchronous") }}</th>
                      <th>{{ $t("system.label.Enabled") }}</th>
                      <th>{{ $t("system.label.ExternalSystem") }}</th>
                      <th class="tHeadCenter">
                        {{ $t("system.label.Actions") }}
                      </th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="index"
                        :data="eventactionMappingData"
                        v-for="(eventactionMappingData, index) in data"
                      >
                        <vs-td :data="eventactionMappingData.eventName">{{
                          eventactionMappingData.eventName
                        }}</vs-td>
                        <vs-td :data="eventactionMappingData.actionName">{{
                          eventactionMappingData.actionName
                        }}</vs-td>
                        <vs-td :data="eventactionMappingData.process">{{
                          eventactionMappingData.process
                        }}</vs-td>

                        <vs-td :data="eventactionMappingData.orderBy">{{
                          eventactionMappingData.orderBy
                        }}</vs-td>
                        <vs-td :data="eventactionMappingData.prePost">{{
                          eventactionMappingData.prePost
                        }}</vs-td>
                        <vs-td :data="eventactionMappingData.processParams">{{
                          eventactionMappingData.processParams
                        }}</vs-td>
                        <vs-td :data="eventactionMappingData.is_synchronous">{{
                          eventactionMappingData.is_synchronous
                        }}</vs-td>
                        <vs-td :data="eventactionMappingData.isDeletedBool">
                          <vs-switch
                            :value="eventactionMappingData.isDeletedBool"
                            @input="updateHooks(eventactionMappingData.id)"
                          />
                        </vs-td>
                        <vs-td :data="eventactionMappingData.externalSystem">{{
                          eventactionMappingData.externalSystem
                        }}</vs-td>
                        <vs-td class="whitespace-no-wrap">
                          <div class="container_img">
                            <feather-icon
                              icon="EditIcon"
                              :title="$t('system.label.Edit')"
                              svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                              @click.stop="
                                editEventActionData(eventactionMappingData.id)
                              "
                              class="icon_row"
                            />
                          </div>
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </div>
            </vs-tab>
            <vs-tab :label="$t('system.label.ENUM')">
              <div>
                <vx-card>
                  <vs-table
                    :max-items="paginationItems[1]"
                    pagination
                    :data="enumConfig"
                    :description="false"
                    search
                    @selected="openView"
                    :description-items="paginationItems"
                    description-title="Registries"
                    description-connector="of"
                    description-body="Pages"
                  >
                    <template slot="header">
                      <div class="list-heading">
                        {{ $t("system.label.ENUM") }}
                      </div>
                      <!-- <div class="mr-2 mb-1 order-1">
                        <vs-button
                          icon-pack="feather"
                          icon="icon-plus"
                          @click="$router.push('/createEnum').catch(() => {})"
                          size="small"
                          >{{ $t("Create ENUM") }}</vs-button
                        >
                      </div> -->
                    </template>
                    <template slot="thead">
                      <th>{{ $t("system.label.ENUM_Name") }}</th>
                      <!-- <th>{{ $t("ENUM Id") }}</th>
                      <th>{{ $t("ENUM Property") }}</th>
                      <th>{{ $t("ENUM Value") }}</th>
                      <th>{{ $t("system.label.Actions") }}</th> -->
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr
                        :key="index"
                        :data="enumData"
                        v-for="(enumData, index) in data"
                      >
                        <vs-td :data="enumData.name">{{ enumData.name }}</vs-td>
                        <!-- <vs-td :data="enumData.id">{{ enumData.id }}</vs-td>
                        <vs-td :data="enumData.type">{{ enumData.type }}</vs-td>
                        <vs-td :data="enumData.value">{{
                          enumData.value
                        }}</vs-td>

                        <vs-td class="whitespace-no-wrap">
                          <feather-icon
                            icon="EditIcon"
                            title="edit"
                            class="text-warning"
                            svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                            @click.stop="editEventActionData(enumData.id)"
                          />
                        </vs-td> -->
                      </vs-tr>
                    </template>
                  </vs-table>
                </vx-card>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
        <div class="centerx">
          <vs-popup
            class="popup-close"
            :title="$t('system.label.EditGlobalConfiguration')"
            :active.sync="editGlobalConfigurationValue"
          >
            <form>
              <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                <div class="vx-col sm:w-full w-full">
                  <vs-input
                    :label="$t('system.label.Value')"
                    type="text"
                    class="w-full font-semibold"
                    v-model="editValueConfig"
                  />
                </div>
              </div>

              <div class="button-container">
                <span class="ml-4 mr-2">
                  <vs-button
                    icon-pack="feather"
                    type="border"
                    @click="editGlobalConfigurationValue = false"
                  >
                    {{ $t("system.label.cancel") }}
                  </vs-button>
                </span>
                <span class="ml-1 mr-3">
                  <vs-button icon-pack="feather" @click="saveValueConfig">
                    {{ $t("system.label.confirm") }}
                  </vs-button>
                </span>
              </div>
            </form>
          </vs-popup>
        </div>

        <!-- edit paymentgatway configuration -->
        <div class="centerx">
          <vs-popup
            class="popup-close"
            :title="$t('system.label.EditPaymentGatewayConfiguration')"
            :active.sync="editPaymentGatwayConfigPopup"
          >
            <div class="">
              <div class="w-full">
                <vs-table
                  :data="keyValues"
                  :description="false"
                  description-title="Registries"
                  description-connector="of"
                  description-body="Pages"
                >
                  <template slot="thead">
                    <th>{{ $t("system.label.Key") }}</th>
                    <th>{{ $t("system.label.Value") }}</th>
                    <th class="tHeadCenter">{{ $t("system.label.Action") }}</th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr
                      :key="index"
                      :data="keyValues"
                      v-for="(valuesPairKeys, index) in data"
                    >
                      <vs-td>
                        <vs-input
                          :label="$t('system.label.EnterKeyHere')"
                          class="w-full font-semibold mb-2"
                          v-model="valuesPairKeys.key"
                          :id="index"
                          :disabled="valuesPairKeys.disable"
                        />
                      </vs-td>
                      <vs-td>
                        <vs-input
                          :id="index"
                          :label="$t('system.label.EnterValueHere')"
                          v-model="valuesPairKeys.value"
                          class="w-full font-semibold mb-2"
                          :disabled="valuesPairKeys.disable"
                        />
                      </vs-td>

                      <vs-td class="whitespace-no-wrap">
                        <div class="container_img">
                          <feather-icon
                            icon="EditIcon"
                            :title="$t('system.label.Edit')"
                            svgClasses="w-5 h-5  stroke-current cursor orange_icon"
                            @click="editConfigParams(index)"
                            class="icon_row"
                          />
                          <button
                            class="bGNone border-none view_editTable_btn"
                            @click="deleteConfigParams(index)"
                          >
                            <feather-icon
                              icon="TrashIcon"
                              :title="$t('system.label.Delete')"
                              svgClasses="w-5 h-5 text-danger stroke-current cursor"
                              class="icon_row"
                            />
                          </button>
                          <feather-icon
                            icon="PlusIcon"
                            :title="$t('system.label.Edit')"
                            class="text-warning icon_row"
                            v-if="keyValues.length - index == 1"
                            svgClasses="w-5 h-5 stroke-current cursor"
                            @click="createConfigParams()"
                          />
                        </div>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <div class="button-container mt-3">
              <span class="ml-4 mr-2">
                <vs-button
                  type="border"
                  @click="editPaymentGatwayConfigPopup = false"
                  >{{ $t("system.label.cancel") }}</vs-button
                >
              </span>
              <span class="ml-1">
                <vs-button @click="editPaymentConfig">{{
                  $t("system.label.Submit")
                }}</vs-button>
              </span>
            </div>
          </vs-popup>
        </div>
        <div class="centerx">
          <vs-popup
            classContent="popup-example"
            :title="$t('system.label.AddConfiguration')"
            :active.sync="createConfigurationPopup"
            class="popup-close"
          >
            <form>
              <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.Name')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="name"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("system.label.Enabled") }}
                      <span class="required"> *</span></small
                    >
                    <v-select
                      :options="enabledOptions"
                      v-model="enabled"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    >
                    </v-select>
                  </div>
                </div>
              </div>

              <div class="vx-row">
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('setup.label.Value')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="value"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full"
                >
                  <vs-input
                    :label="$t('system.label.Module')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="module"
                  />
                </div>
                <div
                  class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mt-4"
                >
                  <vs-input
                    :label="$t('system.label.Description')"
                    class="w-full mb-2 font-semibold starlabel"
                    v-model="description"
                  />
                </div>
              </div>
              <div class="vx-row center my-4">
                <div class="vx-col w-full">
                  <vs-button
                    color="primary"
                    class="footerButton-next mb-5"
                    @click="discountTrigger"
                    >{{ $t("setup.label.Save") }}</vs-button
                  >
                </div>
              </div>
            </form>
          </vs-popup>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import vSelect from "vue-select";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      editGlobalConfigurationValue: false,
      editValueConfig: "",
      editPaymentGatwayConfigPopup: false,
      createConfigurationPopup: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      valuesPair: {},
      valuesPairKeys: "",
      showKey: "",
      showValue: "",
      keyValues: [],
      enabledOptions: [true, false],
      idEditPaymentConfig: "",
      activeTab: 0,
      name: "",
      enabled: "",
      value: "",
      module: "",
      description: "",
    };
  },
  components: {
    AtomSpinner,
    "v-select": vSelect,
  },
  computed: {
    ...mapGetters({
      configurationsData: "configuration/getConfigurationsList",
      paymentGatewayConfigsData: "configuration/getPaymentGatewayConfigsList",
      eventactionMappingData: "configuration/getEventactionMappingList",
      ByIdConfigurationsData: "configuration/getByIdConfigurationsDataList",
    }),
    ...mapState({
      enumConfig: (state) => state.configuration.enumConfig,
    }),
  },
  methods: {
    async getEnumList() {
      this.loading = true;
      try {
        await this.$store.dispatch("configuration/fetchEnumList");
      } catch (e) {
        // this.$toasted.error(e.message);
      }
      this.loading = false;
    },
    openView(enumConfig) {
      this.$router.push({
        name: "View Enum",
        params: { name: enumConfig.name },
      });
    },
    async getConfigurationList() {
      this.loading = true;
      try {
        await this.$store.dispatch("configuration/setConfigurationsList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async getPaymentGatewayConfigsList() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "configuration/setPaymentGatewayConfigsList"
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async getEventactionMappingList() {
      this.loading = true;
      try {
        await this.$store.dispatch("configuration/setEventactionMappingList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async saveValueConfig() {
      let payload = {
        value: this.editValueConfig,
        id: this.ByIdConfigurationsData.id,
      };
      try {
        await this.$store.dispatch(
          "configuration/setEditByIdConfigurationsList",
          payload
        );
        this.getConfigurationList();
        this.editGlobalConfigurationValue = false;
        this.resetForm();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async editGlobalConfigValue(data) {
      this.editValueConfig = data.value;
      let payload = { id: data.id };
      try {
        this.$store.dispatch(
          "configuration/setByIdConfigurationsList",
          payload
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.editGlobalConfigurationValue = true;
    },
    resetForm() {
      this.editValueConfig = "";
    },
    async discountTrigger() {
      if (!this.name || !this.value || !this.module || !this.description) {
        this.warningPopup = true;
        this.errorMessage = "";
        this.warningText = "Fill the required fields!";
      } else {
        try {
          const payload = {
            discountId: this.$route.params.id,
            name: this.name,
            enabled: this.enabled,

            value: this.value,
            module: this.module,
            description: this.description,
          };

          await this.$store.dispatch(
            "configuration/createConfigurationAction",
            payload
          );
          this.getConfigurationList();
          this.name = "";
          this.enabled = "";
          this.value = "";
          this.module = "";
          this.description = "";

          this.createConfigurationPopup = false;

          // this.$router.push({
          //   name: "DiscountRulesAndRates",
          //   params: { id: this.$route.params.id },
          // });
        } catch (e) {
          this.errorMessage = e.message.replace("The parameter", "");
          this.warningPopup = true;
          this.errors = e.message;
        }
      }
    },
    editEventActionData(id) {
      this.$router.push(`/editEventAction/${id}`);
    },
    async editPaymentGatwayConfig(value) {
      this.keyValues = [];
      this.valuesPair = JSON.parse(value.value);
      this.idEditPaymentConfig = value.id;
      for (let key in this.valuesPair) {
        let value = this.valuesPair[key];
        this.showKey = key;
        this.showValue = value;
        this.keyValues.push({ key: key, value: value, disable: true });
      }
      this.editPaymentGatwayConfigPopup = true;
    },
    createConfigParams() {
      this.keyValues.push({ key: "", value: "", disable: false });
    },
    editConfigParams(index) {
      this.keyValues[index].disable = false;
    },
    deleteConfigParams: function (index) {
      this.keyValues.splice(index, 1);
    },
    async editPaymentConfig() {
      let editPaymentValueKey = {};
      this.keyValues.forEach((el) => {
        editPaymentValueKey[el.key] = el.value;
        delete el.disable;
      });
      let payload = {
        value: JSON.stringify(editPaymentValueKey),
        id: this.idEditPaymentConfig,
      };
      try {
        await this.$store.dispatch(
          "configuration/setEditByIdPaymentConfig",
          payload
        );

        this.getPaymentGatewayConfigsList();
        this.editPaymentGatwayConfigPopup = false;
        // this.$router.push("/system_config");
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
    async updateFlag(id, isEnabled) {
      const payload = { enabled: isEnabled ? "true" : "false" };
      try {
        await this.$store.dispatch(
          "configuration/updateConfigurationFlagAction",
          { id, data: payload }
        );
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
    async updatePaymentGatewayFlag(id, isEnabled) {
      const payload = { enabled: isEnabled ? "true" : "false" };
      try {
        await this.$store.dispatch(
          "configuration/updatePaymentgatewayConfigurationFlagAction",
          { id, data: payload }
        );
      } catch (e) {
        this.errorMessage = e.message;
      }
    },
    async updateHooks(id) {
      try {
        await this.$store.dispatch("configuration/updateHooksFlagAction", id);
        // Assuming you have a method to refresh the hooks data, call it here
        this.getEventactionMappingList();
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
  },
  mounted() {
    this.getConfigurationList();
    this.getPaymentGatewayConfigsList();
    this.getEventactionMappingList();
    this.getEnumList();
  },
};
</script>
<style scoped>
.product-order-status.vs-chip-success {
  background: #d5ebdb !important;
  border: 1px solid #34a853;
  color: #34a853 !important;
}
.product-order-status.vs-chip-orange {
  background: #fffae7 !important;
  border: 1px solid #ffcb14;
  color: #ffcb14 !important;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.view_editTable_btn {
  background: transparent;
  cursor: pointer;
}
.width15 {
  max-width: 15%;
  word-break: break-all;
}
.width20 {
  max-width: 20%;
  word-break: break-all;
}
.button-container {
  display: flex;
  justify-content: flex-end;
}
.list-heading1 {
  font-size: 22px;
  font-weight: 500;
}
</style>
